import DOMPurify from 'dompurify';
import './EventInformationContent.scss';

export default function EventInformationContent({ html }: { html: string }) {
	const safeHtml = DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ['style'] });
	return <div className='biz-event-information-content' dangerouslySetInnerHTML={{ __html: safeHtml }} />;
}
